import React, { useState, useContext, useEffect } from 'react';
import './ProductDetails.css';
import { useNavigate, useParams } from 'react-router-dom';
import groceryData from '../../data/groceryData';
import vegetableData from '../../data/vegetableData';
import { CartContext } from '../../CartContext';
import { useLanguage } from '../../LanguageContext';

const ProductDetails = () => {
  const { texts, language } = useLanguage();
  const { id, category } = useParams();
  const data_product = category === 'grocery' ? groceryData : vegetableData;

  const getProductById = (id) => data_product.find((product) => product.id === id);
  const product = getProductById(id);

  const { addToCart } = useContext(CartContext);
  const [selectedQuantity, setSelectedQuantity] = useState(250); // default 250g
  const [calculatedAmount, setCalculatedAmount] = useState(product.price); 
  const [mainImage, setMainImage] = useState('');
  const navigate = useNavigate();

  // Generate weight options for non-packed items
  const generateWeightOptions = () => {
    const options = [];
    // 250g to 2000g (2kg) in steps of 250g
    for (let g = 250; g <= 2000; g += 250) {
      options.push(g);
    }
    // 3kg to 10kg in steps of 1kg
    for (let g = 3000; g <= 10000; g += 1000) {
      options.push(g);
    }
    return options;
  };

  const weightOptions = generateWeightOptions();

  const handleQuantityChange = (event) => {
    const gramsOrUnits = parseInt(event.target.value);

    let amount;
    if (product.is_packed) {
      // If packed, multiply pack price by count
      amount = product.price * gramsOrUnits;
      setSelectedQuantity(gramsOrUnits);
    } else {
      // If loose, calculate based on 250g base price
      amount = (product.price / 250) * gramsOrUnits;
      setSelectedQuantity(gramsOrUnits);
    }
    setCalculatedAmount(amount);
  };

  const handleAddToCart = () => {
      const quantityLabel = product.is_packed
        ? `${selectedQuantity} pack(s)`
        : formatWeight(selectedQuantity);
    
      addToCart({
        ...product,
        quantity: quantityLabel, // store formatted quantity
        price: calculatedAmount,
      });
    
      navigate('/cart');
    };

  useEffect(() => {
    if (product) {
      setMainImage(product.master_image);
    }
  }, [product]);

  const handleImageClick = (image) => setMainImage(image);

  const formatWeight = (grams) => {
    if (grams < 1000) return `${grams}g`;
    return `${grams / 1000}kg`;
  };

  return (
    <div className="product-details">
      <div className="image-gallery">
        <img src={mainImage} alt={product.name} className="main-image" />
        <div className="thumbnail-images">
          <img src={product.master_image} alt={product.name} onClick={() => handleImageClick(product.master_image)} />
          <img src={product.first_image} alt={product.name} onClick={() => handleImageClick(product.first_image)} />
          <img src={product.second_image} alt={product.name} onClick={() => handleImageClick(product.second_image)} />
          <img src={product.third_image} alt={product.name} onClick={() => handleImageClick(product.third_image)} />
        </div>
      </div>

      <div className="product-info">
        <h2>{language === 'si' ? product.si_name : product.name}</h2>
        <p>{language === 'si' ? product.si_description : product.description}</p>
        <p>
          {texts.productDetails.price}: {product.price} {product.is_packed ? '(per pack)' : '(per 250g)'}
        </p>

        <label htmlFor="quantity">
          {texts.productDetails.selectQuantity}: {product.is_packed ? "" : texts.productDetails.selectQuantityDes}
        </label>

        <select id="quantity" value={selectedQuantity} onChange={handleQuantityChange}>
          {product.is_packed
            ? // packed product options (1–10 packs)
              [...Array(10)].map((_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))
            : // loose product options (250g → 2kg step 250g, then 3kg → 10kg step 1kg)
              weightOptions.map((grams) => (
                <option key={grams} value={grams}>
                  {formatWeight(grams)}
                </option>
              ))}
        </select>

        <p>
          {texts.productDetails.selectedQuantity}:{" "}
          {product.is_packed ? `${selectedQuantity} pack(s)` : formatWeight(selectedQuantity)}
        </p>
        <p>
          {texts.productDetails.priceForSelectedQuantity}: {calculatedAmount.toFixed(2)}
        </p>
        <button onClick={handleAddToCart} className="add-to-cart-button">
          {texts.productDetails.addToCart}
        </button>
      </div>
    </div>
  );
};

export default ProductDetails;

